<template>
  <span>
    <span v-if="$store.state.sysInit.manualChatShowWaitingListFlg">
      <el-button
        slot="reference"
        size="small"
        plain
        type="primary"
        :disabled="true"
      >
        保留開始</el-button
      >
    </span>
    <span v-else>
      <span v-if="$store.state.sysInit.showHoldOnButton">
        <span
          v-if="
            $store.state.sysInit.manualChatSendMessageFlg &&
            $store.state.sysInit.waitCloseIssueId.indexOf(
              $store.state.sysInit.manualChatModeIssueId
            ) == -1
          "
        >
          <el-popover
            placement="right"
            width="350"
            trigger="click"
            v-model="visible"
          >
            <div style="background-color: #A5E1FC; height: 30px">
              <span
                style="
                  font-size: 16px;
                  position: absolute;
                  color: #184263;
                  padding-top: 4px;
                  padding-right: 4px;
                  padding-bottom: 4px;
                  padding-left: 15px;
                  font-weight: 600;
                "
              >
                保留開始
              </span>
              <span style="float:right"> <i  @click="visible = false" class="el-icon-close" style="font-size: 18px; font-weight: 600;color: #184263; padding-top: 6px;padding-right: 12px;"></i></span>
            </div>
            <div style="padding: 12px;border: 3px #A5E1FC solid;">
              <div  style="padding-bottom: 5px;padding-left: 10px;padding-right: 10px;">
                保留中はお問い合わせ者画面にキャラクターが登場し、次のセリフが表示されます。
              </div>

              <el-row :gutter="24">
                <el-col :span="6">
                  <img src="../assets/img/monster.png" />
                </el-col>
                <el-col :span="18">
                  <div class="div_message">
                    <div class="user_msg">
                      <div class="speaker">
                        <el-input
                          type="textarea"
                          placeholder="请输入内容"
                          v-model="textarea"
                          resize="none"
                          readonly
                          :autosize="{ minRows: 3, maxRows: 4 }"
                          style="font-weight: bold;font-size: 13px;"
                        >
                        </el-input>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <div style="padding: 10px">
                <el-row :gutter="24">
                  <el-col :span="12" style="padding-left: 45px">
                    <el-button
                      size="small"
                      plain
                      type="primary"
                      @click="holdOnMessage"
                      >保留開始</el-button
                    >
                  </el-col>
                  <el-col :span="10">
                    <el-button size="small" type="info" @click="visible = false"
                      >閉じる
                    </el-button>
                  </el-col>
                </el-row>
              </div>
            </div>

            <el-button
              slot="reference"
              size="small"
              plain
              type="primary"
            >
              保留開始</el-button
            >
          </el-popover>
        </span>

        <span v-else>
          <el-popover
            placement="right"
            width="350"
            trigger="click"
            v-model="visible"
            title="保留開始"
          >
            <div style="padding-bottom: 5px;padding-left: 10px;padding-right: 10px;">
              保留中はお問い合わせ者画面にキャラクターが登場し、次のセリフが表示されます。
            </div>

            <el-row :gutter="24">
              <el-col :span="6">
                <img src="../assets/img/monster.png" />
              </el-col>
              <el-col :span="18">
                <div class="user_msg">
                  <div class="speaker">
                    <el-input
                      type="textarea"
                      placeholder="请输入内容"
                      v-model="textarea"
                      resize="none"
                      readonly
                      :autosize="{ minRows: 4, maxRows: 5 }"
                      style="font-weight: bold;font-size: 13px;"
                    >
                    </el-input>
                  </div>
                </div>
              </el-col>
            </el-row>
            <div style="padding: 10px">
              <el-row :gutter="24">
                <el-col :span="12" style="padding-left: 45px">
                  <el-button
                    size="small"
                    plain
                    type="primary"
                    @click="holdOnMessage"
                    >保留開始</el-button
                  >
                </el-col>
                <el-col :span="10">
                  <el-button size="small" type="info" @click="visible = false"
                    >閉じる
                  </el-button>
                </el-col>
              </el-row>
            </div>

            <el-button
              slot="reference"
              size="small"
              plain
              type="primary"
              :disabled="true"
            >
              保留開始</el-button
            >
          </el-popover>
        </span>
      </span>

      <span v-else>
        <span
          v-if="
            $store.state.sysInit.manualChatSendMessageFlg &&
            $store.state.sysInit.waitCloseIssueId.indexOf(
              $store.state.sysInit.manualChatModeIssueId
            ) == -1
          "
        >
          <el-button type="danger" size="small" plain @click="holdOnFinished"
            >保留終了</el-button
          >
        </span>
        <span v-else>
          <el-button
            slot="reference"
            size="small"
            plain
            type="primary"
            :disabled="true"
          >
            保留開始</el-button
          >
        </span>
      </span>
    </span>
  </span>
</template>

<script>
import moment from "moment";
import {
  orderBy,
  findIndex,
  reverse,
  sortBy,
  toPairs,
  find,
  chunk,
  remove,
  omit,
} from "lodash";
export default {
  data() {
    return {
      visible: false,
      textarea:
        "担当者は現在確認中ですが、時間がかかりそうなので、このままもう少し待っててね。",

      // showHoldOnButton: true,
    };
  },
  methods: {
    holdOnMessage() {
      // this.$store.state.sysInit.manualMessageStatus = "sendEnd";
      if (this.$store.state.sysInit.manualChatModeIssueId) {
        this.$store.dispatch("sysInit/manualChatSendHoldOnMessage", {
          message: this.textarea,
          type: "holdOnStart",
        });
        let data = {
          id: this.$store.state.sysInit.messageId++,
          flag: "left",
          userId: this.$store.state.sysInit.manualChatQuestionerId,
          text: this.textarea,
          checked: false,
          user: this.$store.state.sysInit.html_const.cons_266_moppy_name,//もっぴー
          messageTime: moment().tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm:ss"),
          status: false,
          issueId: this.$store.state.sysInit.manualChatModeIssueId,
          isChatbot: false,
          username:this.$store.state.sysInit.html_const.cons_266_moppy_name
          // chatbotIssueId:this.$store.state.sysInit.manualChatbotIssueId
        };
        this.$store.state.sysInit.manualChatMessageList.push(data);

        if (
          this.$store.state.sysInit.holdOnUserList.indexOf(
            this.$store.state.sysInit.manualChatModeIssueId
          ) == -1
        ) {
          let tempIssueId =
            this.$store.state.sysInit.manualChatModeIssueId.toString();
          this.$store.state.sysInit.holdOnUserList.push(tempIssueId);
        }
        this.$store.dispatch(
          "redmine/manualChatMessageRecord",
          {},
          { root: true }
        );
        this.visible = false;
        this.$store.state.sysInit.showHoldOnButton = false;
      }
    },
    holdOnFinished() {
      let tempId = this.$store.state.sysInit.manualChatModeIssueId;
      remove(this.$store.state.sysInit.holdOnUserList, function (i) {
        return i == tempId;
      });
      this.$store.dispatch("sysInit/manualChatSendHoldOnMessage", {
        message: "",
        type: "holdOnEnd",
      });
      this.$store.state.sysInit.showHoldOnButton = true;
    },
  },
};
</script>
<style>
.el-popover {
  padding: 0px;
  border: 0px;
  border-radius: 5px;
}

.div_message {
  /* width: 220px;
  margin: 0 auto;
  position: relative;
  border: 2px solid;
  border-radius: 4px; */
}
/*
.div_message::before {
  content: "";
  width: 0;
  height: 0;
  border-width: 9px;
  border-style: solid;
  position: absolute;
  top: 40px;
  left: -20px;
  border-color: transparent #000 transparent transparent;
}
.div_message::after {
  content: "";
  width: 0;
  height: 2px;
  border: 8px solid;
  position: absolute;
  top: 40px;
  left: -16px;
  border-color: transparent #f5f7fa transparent transparent;
} */

.el-textarea.is-disabled .el-textarea__inner {
  border: 0;
  padding: 10px;
}
.el-popper[x-placement^=right] .popper__arrow{
  left: -20px
}
</style>